import type { MouseEvent, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button, type ButtonProps } from "antd";

type LinkButtonProps = {
  to: string;
  type?: ButtonProps["type"];
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  children: ReactNode;
};

export const LinkButton: React.FC<LinkButtonProps> = ({
  to,
  type,
  onClick,
  children,
}) => {
  const navigate = useNavigate();

  return (
    <Button
      type={type}
      href={to}
      onClick={(e) => {
        onClick?.(e);
        if (
          !e.defaultPrevented &&
          !e.metaKey &&
          !e.ctrlKey &&
          !e.shiftKey &&
          e.button === 0
        ) {
          e.preventDefault();
          navigate(to);
        }
      }}
    >
      {children}
    </Button>
  );
};
